import { ProcessDeUtil } from '../../../../domain/process-de-util';

export class ComponentPerformer {
    constructor() {
        this.id = ProcessDeUtil.GenerateElementId();
    }
    id: string;
    name: string;
    metadataId: string;
    methodCode: string;
    methodName: string;
    actualParameters: Array<ActualParameter>;
    condition: string;
}

export class ActualParameter {
    code: string;
    value: string;
    valueText: string;
    tag: string;
    fetchValueMode?: any;
    fetchValueSetting?: any;
}
